import './fonts.css';
import './font-awesome.css';
import './normalize.css';
import './bootstrap-grid.css';
import './globals.scss';
import './banner.css';